import React from 'react'
import { useLocation } from 'react-router-dom'

function Directoriestabs() {

    const location = useLocation();

  return (<>
     <div className='tabs' style={{width:"100%"}}>
            <div className='tab_inner directories_tab ' >
                <ul className="nav nav-pills " id="pills-tab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <button className=" nav-link active d_tab " id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true" style={{ color: "#1CAC19", fontSize: "12px" }}>Listing</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link d_tab " id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" style={{ color: "#1CAC19", fontSize: "12px" }}>Posting</button>
                    </li>
                    <li className="nav-item" role="presentation">
                        <button className="nav-link d_tab" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" style={{ color: "#1CAC19", fontSize: "12px" }}>{location.pathname === "/add-website" ? "Users": "Buy & Sell"} </button>
                    </li>
                </ul>
            </div>
            <div className="tab-content" id="pills-tabContent">

            </div>
        </div>
  
  
  
  
  
  </>
    
  )
}

export default Directoriestabs